import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, LeafIcon } from 'lucide-react';
import { images } from '../../data/images';
const ease = [0.23, 1, 0.32, 1] as const;
export function HeroSection() {
  const reduce = useReducedMotion();
  const rise = (delay: number) => ({
    initial: reduce ? false : {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      delay,
      ease
    }
  });
  return <section aria-labelledby="hero-title" className="relative w-full overflow-hidden bg-cream" data-id="element-31" data-mp="laed45ahdo41">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 pb-20 pt-10 md:px-8 lg:grid-cols-12 lg:gap-8 lg:pb-28 lg:pt-16" data-id="element-32" data-mp="7b4yha1xb226">
        <div className="flex flex-col justify-center lg:col-span-6" data-id="element-33" data-mp="bcq7gkbc6w73">
          <motion.p {...rise(0)} className="flex items-center gap-2 text-sm font-medium text-aloe-700" data-id="element-34" data-mp="21nup9iwzvv5c">
            <LeafIcon className="h-4 w-4" aria-hidden="true" data-id="element-35" data-mp="25q9csgblzj2y" />
            Cosmétiques & compléments alimentaires à l’Aloe Vera
          </motion.p>
          <motion.h1 {...rise(0.05)} id="hero-title" className="mt-6 font-serif text-[3.4rem] leading-[0.95] tracking-[-0.01em] text-aloe-900 sm:text-7xl xl:text-[6.5rem]" data-id="element-36" data-mp="2ac5vz6csx9si">
            L’aloe vera,
            <br data-id="element-37" data-mp="2f4p8s13o00w9" />
            <span className="italic text-sage" data-id="element-38" data-mp="2f60fo9seporl">cultivée</span> avec
            <br data-id="element-39" data-mp="1rf4mp9c7snir" />
            soin.
          </motion.h1>
          <motion.p {...rise(0.1)} className="mt-8 max-w-md text-lg leading-relaxed text-ink/70" data-id="element-40" data-mp="1rfmsoxooig3v">
            Aloesol, c’est des cosmétiques et des compléments alimentaires certifiés bio, à base d’aloe vera fraîche
            d’Andalousie.
          </motion.p>
          <motion.div {...rise(0.15)} className="mt-10 flex flex-wrap items-center gap-3" data-id="element-41" data-mp="1we7s4uw3wvr9">
            <a href="#nouveautes" className="group inline-flex items-center gap-2 rounded-full bg-aloe-900 px-7 py-4 text-sm font-semibold text-cream transition-colors duration-150 ease-out hover:bg-aloe-700" data-id="element-42" data-mp="3cry1ag232a7r">
              Découvrir les nouveautés
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-43" data-mp="3jvea2ti78zmc" />
            </a>
            <Link to="/la-marque/notre-histoire" className="inline-flex items-center gap-2 rounded-full px-6 py-4 text-sm font-semibold text-aloe-900 ring-1 ring-inset ring-aloe-900/20 transition-colors duration-150 ease-out hover:bg-sand" data-id="element-44" data-mp="3ovjvvt1sfrwi">
              Notre histoire
            </Link>
          </motion.div>
        </div>

        <div className="relative lg:col-span-6" data-id="element-45" data-mp="363zivze51s47">
          <div className="grid h-full grid-cols-5 grid-rows-6 gap-3 md:gap-4" style={{
          minHeight: 'min(640px, 110vw)'
        }} data-id="element-46" data-mp="362fybwlg8uwm">
            <motion.div initial={reduce ? false : {
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            delay: 0.1,
            ease
          }} className="col-span-3 row-span-6 overflow-hidden rounded-[2rem] bg-sage" data-id="element-47" data-mp="2dfv66tx5ges0">
              <img src={images.heroLifestyle} alt="Soin à l’aloe vera Aloesol appliqué sur la peau" className="h-full w-full object-cover" data-id="element-48" data-mp="vii3idvl1zzd" />
            </motion.div>
            <motion.div initial={reduce ? false : {
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            delay: 0.16,
            ease
          }} className="col-span-2 row-span-3 overflow-hidden rounded-[2rem] bg-sand" data-id="element-49" data-mp="lizkq0resk8w">
              <img src={images.lifestyleSecondary} alt="Produits Aloesol" className="h-full w-full object-cover" data-id="element-50" data-mp="7tpbutlzueak" />
            </motion.div>
            <motion.div initial={reduce ? false : {
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            delay: 0.22,
            ease
          }} className="col-span-2 row-span-3 flex flex-col justify-between rounded-[2rem] bg-aloe-900 p-5 text-cream md:p-7" data-id="element-51" data-mp="2rgme78bxud7">
              <span className="text-xs font-medium text-cream/60 md:text-sm" data-id="element-52" data-mp="1xwzhvbz3z9cu">Gel certifié bio</span>
              <div data-id="element-53" data-mp="1j8lb4pykn0r0">
                <p className="font-serif text-6xl leading-none md:text-8xl" data-id="element-54" data-mp="1j7abn2c5sf5p">
                  97<span className="text-leaf" data-id="element-55" data-mp="1o5v0y6pvhefd">%</span>
                </p>
                <p className="mt-2 text-sm text-cream/80" data-id="element-56" data-mp="1a7etueo3llwp">d’Aloe Vera d’Andalousie</p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}